(function () {
  'use strict';

  var initialized = new WeakSet();
  var imageCache = {};

  function loadImage(src, callback) {
    if (!src) return;
    if (imageCache[src]) {
      if (imageCache[src].complete) callback(imageCache[src]);
      else imageCache[src].addEventListener('load', function () { callback(imageCache[src]); }, { once: true });
      return;
    }
    var image = new Image();
    image.crossOrigin = 'anonymous';
    image.src = src;
    imageCache[src] = image;
    image.addEventListener('load', function () { callback(image); }, { once: true });
  }

  function fontString(px, script, bold) {
    if (script) return px + 'px "Dancing Script", cursive';
    return (bold ? '700 ' : '') + px + 'px "Libre Baskerville", Baskerville, Georgia, serif';
  }

  function drawLine(ctx, text, px, script, bold, cx, baselineY, color, ghost, maxWidth) {
    if (!text) return;
    ctx.save();
    ctx.font = fontString(px, script, bold);
    var width = ctx.measureText(text).width;
    if (width > maxWidth) {
      px = Math.max(9, Math.floor(px * maxWidth / width));
      ctx.font = fontString(px, script, bold);
      width = ctx.measureText(text).width;
      while (width > maxWidth && px > 9) {
        px -= 1;
        ctx.font = fontString(px, script, bold);
        width = ctx.measureText(text).width;
      }
    }
    ctx.textAlign = 'center';
    ctx.textBaseline = 'alphabetic';
    ctx.fillStyle = color;
    ctx.globalAlpha = ghost ? 0.42 : 0.96;
    ctx.shadowColor = 'rgba(0,0,0,0.32)';
    ctx.shadowBlur = 1.1;
    ctx.fillText(text, cx, baselineY);
    ctx.restore();
  }

  function wrapText(ctx, text, px, script, maxWidth) {
    ctx.font = fontString(px, script, false);
    var words = String(text || '').trim().split(/\s+/).filter(Boolean);
    var lines = [];
    var current = '';
    words.forEach(function (word) {
      var test = current ? current + ' ' + word : word;
      if (current && ctx.measureText(test).width > maxWidth) {
        lines.push(current);
        current = word;
      } else {
        current = test;
      }
    });
    if (current) lines.push(current);
    return lines;
  }

  function wrapFit(ctx, text, basePx, script, maxWidth, maxLines) {
    var px = basePx;
    for (var i = 0; i < 14; i += 1) {
      var lines = wrapText(ctx, text, px, script, maxWidth);
      var widest = 0;
      ctx.font = fontString(px, script, false);
      lines.forEach(function (line) { widest = Math.max(widest, ctx.measureText(line).width); });
      if (lines.length <= maxLines && widest <= maxWidth) return { px: px, lines: lines };
      px = Math.floor(px * 0.9);
    }
    return { px: px, lines: wrapText(ctx, text, px, script, maxWidth).slice(0, maxLines) };
  }

  function keyForColor(value) {
    value = String(value || '');
    if (/square/i.test(value)) return 'black-square';
    if (/white/i.test(value)) return 'white-heart';
    if (/black/i.test(value)) return 'black-heart';
    return 'red-heart';
  }

  function initRoot(root) {
    if (!root || initialized.has(root)) return;
    initialized.add(root);

    var configNode = root.querySelector('[data-mgp-config]');
    if (!configNode) return;
    var config;
    try { config = JSON.parse(configNode.textContent); }
    catch (error) { console.error('Memorial personalization config error', error); return; }

    var form = document.getElementById(config.formId);
    if (!form) { console.error('Memorial personalization form not found', config.formId); return; }

    var state = {
      name: '',
      birth: '',
      pass: '',
      saying: '',
      saying1: '',
      saying2: '',
      font: 'Elegant Script (Dancing Script)',
      sayingOn: false,
      fingerprintOn: false,
      colorKey: 'red-heart'
    };

    function productInfo() {
      return root.closest('product-info') || document;
    }

    function personalizationSelect() {
      return productInfo().querySelector('select[name="options[Personalization]"]');
    }

    function hidePersonalizationOption() {
      var select = personalizationSelect();
      if (!select) return;
      var wrapper = select.closest('.product-form__input');
      if (wrapper) wrapper.classList.add('mgp-hidden-personalization-option');
    }

    function comboName() {
      var order = ['Saying', 'Fingerprint', 'Rush'];
      var checked = {};
      root.querySelectorAll('[data-mgp-toggle]:checked').forEach(function (box) { checked[box.dataset.combo] = true; });
      var parts = order.filter(function (name) { return checked[name]; });
      return parts.length ? parts.join(' + ') : 'Base';
    }

    function syncVariant() {
      hidePersonalizationOption();
      var select = personalizationSelect();
      if (!select) return;
      var combo = comboName();
      if (select.value !== combo) {
        var exists = Array.from(select.options).some(function (option) { return option.value === combo; });
        if (!exists) {
          console.error('Personalization variant missing', combo);
          return;
        }
        select.value = combo;
        select.dispatchEvent(new Event('change', { bubbles: true }));
      }
      var idInput = form.querySelector('input[name="id"]');
      if (idInput) idInput.removeAttribute('disabled');
    }

    var priceElement = productInfo().querySelector('[id^="price-"]');
    var discountRatio = null;
    var applyingPrice = false;

    function moneyAmounts(text) {
      var matches = String(text || '').match(/[0-9]+(?:,[0-9]{3})*(?:\.[0-9]{1,2})?/g) || [];
      return matches.map(function (value) { return parseFloat(value.replace(/,/g, '')); }).filter(function (value) { return isFinite(value); });
    }

    function formatMoney(cents) {
      return new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(cents / 100);
    }

    function captureDiscountRatio() {
      if (discountRatio || !priceElement) return;
      var discountRoot = priceElement.querySelector('[data-la-dn-replaced-root]');
      if (!discountRoot) return;
      var moneyNodes = discountRoot.querySelectorAll('span.money');
      if (moneyNodes.length < 2) return;
      var discountedAmounts = moneyAmounts(moneyNodes[0].textContent);
      var originalAmounts = moneyAmounts(moneyNodes[moneyNodes.length - 1].textContent);
      if (!discountedAmounts.length || !originalAmounts.length) return;
      var discounted = discountedAmounts[0];
      var original = originalAmounts[0];
      var expectedBase = Number(config.basePriceCents || 0) / 100;
      if (expectedBase && Math.abs(original - expectedBase) > 0.02) return;
      var ratio = discounted / original;
      if (ratio > 0.5 && ratio < 0.99) {
        discountRatio = ratio;
        decorateAddonPrices();
      }
    }

    function decorateAddonPrices() {
      if (!discountRatio) return;
      var percent = Math.round((1 - discountRatio) * 100);
      var note = root.querySelector('[data-mgp-sale-note]');
      if (note) {
        note.textContent = 'Personalization add-ons are ' + percent + '% off, applied automatically.';
        note.hidden = false;
      }
      root.querySelectorAll('[data-mgp-toggle][data-price]').forEach(function (box) {
        var row = box.closest('.mgp__addon-row');
        var price = row && row.querySelector('.mgp__addon-price');
        if (!price || price.dataset.decorated) return;
        var full = parseInt(box.dataset.price, 10) || 0;
        var sale = Math.round(full * discountRatio);
        price.innerHTML = '<s>+' + formatMoney(full) + '</s>+' + formatMoney(sale);
        price.dataset.decorated = 'true';
      });
    }

    function applyDiscountedVariantPrice() {
      if (!priceElement || applyingPrice) return;
      captureDiscountRatio();
      if (!discountRatio) return;
      if (priceElement.querySelector('[data-la-dn-replaced-root]')) return;
      var price = priceElement.querySelector('.price');
      if (!price || price.classList.contains('mgp-price-adjusted')) return;
      var regular = price.querySelector('.price__regular .price-item--regular');
      var amounts = moneyAmounts(regular ? regular.textContent : price.innerText);
      if (!amounts.length) return;
      var fullCents = Math.round(amounts[0] * 100);
      var saleCents = Math.round(fullCents * discountRatio);
      applyingPrice = true;
      price.classList.add('price--on-sale', 'mgp-price-adjusted');
      var crossed = price.querySelector('.price__sale .price-item--regular');
      var sale = price.querySelector('.price__sale .price-item--sale');
      if (crossed) crossed.textContent = formatMoney(fullCents);
      if (sale) sale.textContent = formatMoney(saleCents);
      applyingPrice = false;
    }

    function schedulePriceUpdate() {
      [50, 450, 1200].forEach(function (delay) { setTimeout(applyDiscountedVariantPrice, delay); });
    }

    function compactFrontConfig() {
      if (config.shape === 'dog') {
        return { cx: 0.516, nameFont: 0.043, nameY: 0.415, yearFont: 0.026, yearY: 0.455, maxW: 0.34 };
      }
      return { cx: 0.500, nameFont: 0.057, nameY: 0.410, yearFont: 0.031, yearY: 0.475, maxW: 0.62 };
    }

    function renderCompactFront() {
      var canvas = root.querySelector('[data-mgp-front]');
      if (!canvas || !canvas.getContext) return;
      var cfg = compactFrontConfig();
      loadImage(config.images.front, function (image) {
        var ctx = canvas.getContext('2d');
        var width = canvas.width;
        var height = canvas.height;
        ctx.clearRect(0, 0, width, height);
        ctx.drawImage(image, 0, 0, width, height);
        var name = state.name.trim();
        var years = state.birth || state.pass ? (state.birth || '') + '-' + (state.pass || '') : '';
        drawLine(ctx, name || 'Their Name', Math.round(cfg.nameFont * height), false, false, width * cfg.cx, height * cfg.nameY, '#E9E6E0', !name, width * cfg.maxW);
        drawLine(ctx, years || '1935-2026', Math.round(cfg.yearFont * height), false, true, width * cfg.cx, height * cfg.yearY, '#E9E6E0', !years, width * cfg.maxW);
      });
    }

    function renderCompactBack() {
      var canvas = root.querySelector('[data-mgp-back]');
      if (!canvas || !canvas.getContext || !state.sayingOn) return;
      loadImage(config.images.back, function (image) {
        var ctx = canvas.getContext('2d');
        var width = canvas.width;
        var height = canvas.height;
        ctx.clearRect(0, 0, width, height);
        ctx.drawImage(image, 0, 0, width, height);
        var text = state.saying.trim();
        var ghost = !text;
        text = text || 'Forever in my heart';
        var script = state.font.indexOf('Classic Serif') !== 0;
        var maxWidth = width * (config.shape === 'dog' ? 0.46 : 0.60);
        var basePx = Math.round(height * (script ? (config.shape === 'dog' ? 0.082 : 0.075) : (config.shape === 'dog' ? 0.056 : 0.052)));
        var fit = wrapFit(ctx, text, basePx, script, maxWidth, 3);
        var lineHeight = fit.px * 1.28;
        var centerY = height * 0.50;
        var startY = centerY - ((fit.lines.length - 1) * lineHeight) / 2 + fit.px * 0.34;
        fit.lines.forEach(function (line, index) {
          drawLine(ctx, line, fit.px, script, false, width * 0.5, startY + index * lineHeight, '#E9E6E0', ghost, maxWidth);
        });
      });
    }

    var medallionConfig = {
      'red-heart': { qr: [0.3343, 0.3509, 0.6750, 0.6944], color: '#E8E3DC', shape: 'heart' },
      'black-heart': { qr: [0.3296, 0.3481, 0.6796, 0.6972], color: '#E8E3DC', shape: 'heart' },
      'white-heart': { qr: [0.3426, 0.3500, 0.6759, 0.6991], color: '#55504D', shape: 'heart' },
      'black-square': { qr: [0.3574, 0.3398, 0.6537, 0.6333], color: '#E8E3DC', shape: 'square' }
    };

    function renderMedallionBase() {
      var canvas = root.querySelector('[data-mgp-front]');
      if (!canvas || !canvas.getContext) return;
      var key = state.colorKey;
      var cfg = medallionConfig[key];
      loadImage(config.images[key], function (image) {
        if (state.colorKey !== key) return;
        var ctx = canvas.getContext('2d');
        var width = canvas.width;
        var height = canvas.height;
        ctx.clearRect(0, 0, width, height);
        ctx.drawImage(image, 0, 0, width, height);

        var qx0 = cfg.qr[0] * width;
        var qy0 = cfg.qr[1] * height;
        var qx1 = cfg.qr[2] * width;
        var size = qx1 - qx0;
        var cx = (qx0 + qx1) / 2;
        var isSquare = cfg.shape === 'square';
        var name = state.name.trim();
        var years = state.birth || state.pass ? (state.birth || '') + '-' + (state.pass || '') : '';
        var maxWidth = size * (isSquare ? 1.40 : 1.90);

        drawLine(ctx, name || 'Their Name', Math.round(size * (isSquare ? 0.131 : 0.150)), false, false, cx, qy0 - size * (isSquare ? 0.159 : 0.166), cfg.color, !name, maxWidth);
        drawLine(ctx, years || '1935-2026', Math.round(size * (isSquare ? 0.078 : 0.100)), false, true, cx, qy0 - size * (isSquare ? 0.051 : 0.050), cfg.color, !years, maxWidth);
      });
    }

    var sayingPreviewConfig = {
      'red-heart': { imageKey: 'saying-red-heart', cx: 0.506, color: '#E8E3DC', shape: 'heart' },
      'black-heart': { imageKey: 'saying-black-heart', cx: 0.504, color: '#E8E3DC', shape: 'heart' },
      'white-heart': { imageKey: 'saying-white-heart', cx: 0.509, color: '#55504D', shape: 'heart' },
      'black-square': { imageKey: 'saying-black-square', cx: 0.506, color: '#E8E3DC', shape: 'square' }
    };

    function renderMedallionSaying() {
      if (!state.sayingOn) return;
      var canvas = root.querySelector('[data-mgp-saying-preview]');
      if (!canvas || !canvas.getContext) return;
      var key = state.colorKey;
      var cfg = sayingPreviewConfig[key];
      loadImage(config.images[cfg.imageKey], function (image) {
        if (state.colorKey !== key || !state.sayingOn) return;
        var ctx = canvas.getContext('2d');
        var width = canvas.width;
        var height = canvas.height;
        ctx.clearRect(0, 0, width, height);
        ctx.drawImage(image, 0, 0, width, height);

        var isSquare = cfg.shape === 'square';
        var cx = cfg.cx * width;
        var maxWidth = width * (isSquare ? 0.43 : 0.72);
        var name = state.name.trim();
        var years = state.birth || state.pass ? (state.birth || '') + '-' + (state.pass || '') : '';
        var script = state.font.indexOf('Classic Serif') !== 0;
        var line1 = state.saying1.trim();
        var line2 = state.saying2.trim();
        var ghost = !line1 && !line2;
        var lines = ghost ? ['You were our greatest blessing', 'and our hardest goodbye'] : [line1, line2].filter(Boolean);

        drawLine(ctx, name || 'Their Name', Math.round(height * (isSquare ? 0.040 : 0.065)), false, false, cx, height * (isSquare ? 0.275 : 0.300), cfg.color, !name, maxWidth);
        drawLine(ctx, years || '1935-2026', Math.round(height * (isSquare ? 0.024 : 0.037)), false, true, cx, height * (isSquare ? 0.315 : 0.350), cfg.color, !years, maxWidth);

        var sayingPx = Math.round(height * (script ? (isSquare ? 0.035 : 0.052) : (isSquare ? 0.025 : 0.035)));
        ctx.font = fontString(sayingPx, script, false);
        var widest = 0;
        lines.forEach(function (line) { widest = Math.max(widest, ctx.measureText(line).width); });
        if (widest > maxWidth) {
          sayingPx = Math.max(9, Math.floor(sayingPx * maxWidth / widest));
          ctx.font = fontString(sayingPx, script, false);
          widest = 0;
          lines.forEach(function (line) { widest = Math.max(widest, ctx.measureText(line).width); });
          while (widest > maxWidth && sayingPx > 9) {
            sayingPx -= 1;
            ctx.font = fontString(sayingPx, script, false);
            widest = 0;
            lines.forEach(function (line) { widest = Math.max(widest, ctx.measureText(line).width); });
          }
        }
        var positions = lines.length === 1
          ? [height * (isSquare ? 0.388 : 0.445)]
          : [height * (isSquare ? 0.365 : 0.415), height * (isSquare ? 0.410 : 0.475)];
        lines.forEach(function (line, index) {
          drawLine(ctx, line, sayingPx, script, false, cx, positions[index], cfg.color, ghost, maxWidth);
        });
      });
    }

    function renderAll() {
      if (config.mode === 'compact') {
        renderCompactFront();
        renderCompactBack();
      } else {
        renderMedallionBase();
        renderMedallionSaying();
      }
      updateNotes();
    }

    function updateNotes() {
      var frontNote = root.querySelector('[data-mgp-front-note]');
      var backNote = root.querySelector('[data-mgp-back-note]');
      var sayingNote = root.querySelector('[data-mgp-saying-note]');
      if (config.mode === 'compact') {
        if (frontNote) frontNote.textContent = 'Preview only. Actual engraving may vary slightly.';
        if (backNote) {
          backNote.textContent = 'Saying preview is approximate. Final line breaks, size and placement are adjusted by our engraving team for legibility.' +
            (state.fingerprintOn ? ' Fingerprint placement is determined by our engraving team and is not shown in the preview.' : '');
        }
      } else {
        if (frontNote) frontNote.textContent = 'Preview only. Actual engraving may vary slightly.';
        if (sayingNote) {
          sayingNote.textContent = state.fingerprintOn
            ? 'Saying shown. Fingerprint placement is determined by our engraving team and is not shown in the preview.'
            : 'Preview only. Actual engraving may vary slightly.';
        }
      }
    }

    function updateColorFromPage() {
      var scope = productInfo();
      var select = scope.querySelector('select[name="options[Color]"]');
      var radio = scope.querySelector('input[name="Color"]:checked, input[name="Color-1"]:checked');
      var value = select ? select.value : (radio ? radio.value : 'Red');
      state.colorKey = keyForColor(value);
    }

    root.addEventListener('input', function (event) {
      var name = event.target && event.target.getAttribute && event.target.getAttribute('name');
      if (name === 'properties[Name]') state.name = event.target.value;
      else if (name === 'properties[Saying]') state.saying = event.target.value;
      else if (name === 'properties[Saying Line 1]') state.saying1 = event.target.value;
      else if (name === 'properties[Saying Line 2]') state.saying2 = event.target.value;
      else return;
      renderAll();
    });

    root.addEventListener('change', function (event) {
      var target = event.target;
      var name = target && target.getAttribute && target.getAttribute('name');
      if (name === 'properties[Birth]') state.birth = target.value;
      else if (name === 'properties[Year of Passing]') state.pass = target.value;
      else if (name === 'properties[Saying Font]') state.font = target.value;
      else return;
      renderAll();
    });

    document.addEventListener('change', function (event) {
      var name = event.target && event.target.getAttribute && event.target.getAttribute('name');
      if (name === 'options[Color]' || name === 'Color' || name === 'Color-1') {
        updateColorFromPage();
        renderAll();
      }
    }, true);

    root.querySelectorAll('[data-mgp-toggle]').forEach(function (box) {
      box.addEventListener('change', function () {
        var panel = box.dataset.panel ? document.getElementById(box.dataset.panel) : null;
        if (panel) {
          panel.hidden = !box.checked;
          panel.querySelectorAll('input, textarea, select').forEach(function (field) {
            field.disabled = !box.checked;
            if (!box.checked || field.type === 'radio' || field.hasAttribute('data-optional')) field.required = false;
            else field.required = true;
          });
        }
        if (box.dataset.hiddenInput) {
          var hidden = document.getElementById(box.dataset.hiddenInput);
          if (hidden) hidden.disabled = !box.checked;
        }
        if (box.dataset.combo === 'Saying') state.sayingOn = box.checked;
        if (box.dataset.combo === 'Fingerprint') state.fingerprintOn = box.checked;
        syncVariant();
        schedulePriceUpdate();
        renderAll();
      });
    });

    root.querySelectorAll('input[maxlength], textarea[maxlength]').forEach(function (input) {
      var counter = root.querySelector('[data-count-for="' + input.id + '"]');
      if (!counter) return;
      input.addEventListener('input', function () { counter.textContent = input.maxLength - input.value.length; });
    });

    var submitting = false;
    document.addEventListener('submit', function (event) {
      if (event.target !== form) return;
      syncVariant();
      var fingerprintOn = root.querySelector('[data-mgp-toggle][data-combo="Fingerprint"]:checked');
      if (!fingerprintOn) return;
      event.preventDefault();
      event.stopPropagation();
      if (submitting) return;
      submitting = true;
      var button = form.querySelector('[type="submit"]');
      var buttonText = button ? button.querySelector('span') : null;
      var origText = buttonText ? buttonText.textContent : null;
      if (button) {
        button.setAttribute('disabled', 'disabled');
        if (buttonText) buttonText.textContent = 'Adding...';
      }
      var mgFrame = document.getElementById('MgUploadTargetFrame');
      if (!mgFrame) {
        mgFrame = document.createElement('iframe');
        mgFrame.id = 'MgUploadTargetFrame';
        mgFrame.name = 'MgUploadTargetFrame';
        mgFrame.style.display = 'none';
        document.body.appendChild(mgFrame);
      }
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (before) {
        var countBefore = before.item_count;
        mgFrame.onload = function () {
          mgFrame.onload = null;
          form.removeAttribute('target');
          fetch('/cart.js').then(function (r) { return r.json(); }).then(function (after) {
            if (after.item_count > countBefore && window.__mgDrawerRefresh) {
              window.__mgDrawerRefresh(true).then(function (ok) {
                if (!ok) { window.location.href = '/cart'; return; }
                submitting = false;
                if (button) { button.removeAttribute('disabled'); if (buttonText && origText !== null) buttonText.textContent = origText; }
              }).catch(function () { window.location.href = '/cart'; });
            } else {
              window.location.href = '/cart';
            }
          }).catch(function () { window.location.href = '/cart'; });
        };
        form.setAttribute('target', 'MgUploadTargetFrame');
        HTMLFormElement.prototype.submit.call(form);
      }).catch(function () {
        HTMLFormElement.prototype.submit.call(form);
      });
    }, true);

    document.addEventListener('mg:variant-updated', function () {
      hidePersonalizationOption();
      schedulePriceUpdate();
    });

    if (priceElement && window.MutationObserver) {
      new MutationObserver(function () {
        if (!applyingPrice) schedulePriceUpdate();
      }).observe(priceElement, { childList: true, subtree: true, characterData: true });
    }
    captureDiscountRatio();
    [500, 1500, 3500].forEach(function (delay) { setTimeout(captureDiscountRatio, delay); });

    updateColorFromPage();
    hidePersonalizationOption();
    syncVariant();
    schedulePriceUpdate();
    renderAll();
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(renderAll);
  }

  function scan() {
    document.querySelectorAll('[data-mgp-root]').forEach(initRoot);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', scan);
  else scan();
})();
